import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-TagIcon',
	redDot: 'c-TagIcon__RedDot',
};

export const Style = {
	[CSS.container]: {
		width: 'inherit',
		height: 'inherit',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'box-sizing': 'border-box',
		fontFamily: DefaultTheme.font.familyCondensed,
		fontWeight: DefaultTheme.font.weight.bold,
		boxShadow: DefaultTheme.shadow.box.dp2,
		color: DefaultTheme.font.color.primary,
		border: '2px solid',
		position: 'relative',
	},
	[CSS.redDot]: {
		position: 'absolute',
		top: '-2px',
		right: '-2px',
		width: '8px',
		height: '8px',
		'border-radius': '50%',
		'background-color': ColorPalette2022Branding.lightRed,
		border: '1px solid #FFFFFF',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'pointer-events': 'none',
	},
};
